import {Pipe, PipeTransform} from '@angular/core';
import {
  FieldConfig,
  FieldConfigType,
  Competitor, CustomFieldValue, FieldConfigOption,
} from '@model';
import {TranslocoService} from "@ngneat/transloco";
import {getLanguageValue} from "@utility";
import {LocalizedDatePipe} from "./localized-date.pipe";
import {FormatTimePipe} from "./format-time.pipe";

@Pipe({
  name: 'competitorFieldValue',
})
export class CompetitorFieldValuePipe implements PipeTransform {
  constructor(private translocoService: TranslocoService, private localizedDatePipe: LocalizedDatePipe, private formatTimePipe: FormatTimePipe) {
  }

  transform(fieldConfig: FieldConfig, competitor: Competitor): string | undefined {
    const fieldConfigValue: CustomFieldValue | undefined = competitor.customFieldValues?.find(
      (value: CustomFieldValue): boolean => value.fieldId === fieldConfig.id
    );
    if (fieldConfigValue) {
      switch (fieldConfig.fieldConfigTypeId) {
        case FieldConfigType.BOOLEAN:
          if (fieldConfigValue.boolValue === true) {
            return this.translocoService.translate("app.common.yes")
          }
          if (fieldConfigValue.boolValue === false) {
            return this.translocoService.translate("app.common.no")
          }
          return undefined;
        case FieldConfigType.SELECT:
        case FieldConfigType.MULTISELECT:
          return (
            (fieldConfigValue.numberList?.map((selection: number) => {
              const option: FieldConfigOption | undefined = fieldConfig.options?.find(
                (option: FieldConfigOption) => option.id === selection
              );
              if (option) {
                return getLanguageValue(
                  option.name,
                  option.nameEng,
                  option.nameIta,
                  option.nameSlo,
                  this.translocoService.getActiveLang(), option.name ?? option.nameEng ?? option.nameIta ?? option.nameSlo
                );
              }
              return undefined;
            }) ?? []).join(', ')
          );
        case FieldConfigType.TEXT:
          return fieldConfigValue.inputString;
        case FieldConfigType.DATE:
          return this.localizedDatePipe.transform(fieldConfigValue.dateValue, 'shortDate')
        case FieldConfigType.NUMBER:
          return fieldConfigValue.numberValue?.toString();
        case FieldConfigType.TIME:
          return this.formatTimePipe.transform(fieldConfigValue.customTimeValue);
      }
    }
    return undefined;
  }
}
